import { cn } from '@/lib/utils'

interface RiskScoreBarProps {
  score: number
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
  className?: string
}

export function RiskScoreBar({ 
  score, 
  size = 'md', 
  showLabel = true,
  className 
}: RiskScoreBarProps) {
  const getRiskLevel = (score: number) => {
    if (score >= 81) return 'critical'
    if (score >= 61) return 'high'
    if (score >= 31) return 'medium'
    return 'low'
  }
  
  const getRiskColor = (level: string) => {
    switch (level) {
      case 'critical':
        return 'bg-risk-critical'
      case 'high':
        return 'bg-risk-high'
      case 'medium':
        return 'bg-risk-medium'
      case 'low':
        return 'bg-risk-low'
      default:
        return 'bg-muted'
    }
  }
  
  const getSizeClasses = (size: string) => {
    switch (size) {
      case 'sm':
        return 'h-1.5 text-xs'
      case 'lg':
        return 'h-3 text-base'
      default:
        return 'h-2 text-sm'
    }
  }
  
  const level = getRiskLevel(score)
  const colorClass = getRiskColor(level)
  const sizeClasses = getSizeClasses(size)
  
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className={cn(
        'flex-1 bg-muted rounded-full overflow-hidden',
        sizeClasses
      )}>
        <div
          className={cn(
            'transition-all duration-300 rounded-full',
            colorClass,
            sizeClasses
          )}
          style={{ width: `${Math.min(score, 100)}%` }}
        />
      </div>
      
      {showLabel && (
        <div className="flex items-center gap-1 min-w-0">
          <span className={cn('font-medium tabular-nums', sizeClasses)}>
            {score}
          </span>
          
          <span className={cn(
            'px-1.5 py-0.5 rounded text-white text-xs font-medium capitalize',
            colorClass
          )}>
            {level}
          </span>
        </div>
      )}
    </div>
  )
}